import FilterLogic from './filter-logic'

class FilterInterface {
	constructor(options) {
		this.options = options
		this.el = options.el

		const filterLogicOptions = options.filterLogicOptions || {}

		this.filterLogic = new FilterLogic({
			allowMultiple: true,
			container: this.el,
			history: false,
			setQueryParams: true,
			changeListener: this.onFilterChange.bind(this),
			...filterLogicOptions,
		})

		this.filters = Array.from(this.el.querySelectorAll('[data-filter]')).map((el) => {
			return {
				el: el,
				group: el.dataset.filterGroup,
				filter: el.dataset.filter,
			}
		})

		// Every filter (except the "*" reset) needs a data-filter-group. Without it
		// the group can't be matched on click (undefined group) and the filter
		// silently does nothing. Warn about any offenders.
		const missingGroup = this.filters.filter((f) => f.filter !== '*' && !f.group)
		if (missingGroup.length) {
			console.warn(
				'[ContentFilter] These filter buttons are missing a `data-filter-group` and will not work:',
				missingGroup.map((f) => f.el),
			)
		}

		// clear button
		this.elClearBtn = this.el.querySelector('.js-clear-filters')
		if (this.elClearBtn) {
			this.bndOnClickClear = this.onClickClear.bind(this)
			this.elClearBtn.addEventListener('click', this.bndOnClickClear)
		}

		this.filterLogic.init()
	}
	onClickClear(ev) {
		ev.preventDefault()
		ev.stopPropagation()
		if (this.filterLogic) {
			this.filterLogic.clear(true)
		}

		if (this.options.onClear) {
			this.options.onClear()
		}
	}
	onFilterChange(data) {
		if (this.options.onFilterChange) {
			this.options.onFilterChange(data)
		}
		this.updateFilterUI(data)
	}
	updateFilterUI(data) {
		// check if there are active filters
		const activeFilters = data.reduce((acc, item) => {
			if (item.active) {
				acc = acc + item.active.length
			}
			return acc
		}, 0)

		if (activeFilters > 0) {
			this.el.classList.add('has-active-filters')
		} else {
			this.el.classList.remove('has-active-filters')
		}

		// update filter buttons
		data.forEach((filterGroup) => {
			this.filters.forEach((filterObj) => {
				if (filterObj.group !== filterGroup.group) return
				if (filterGroup.active.includes(filterObj.filter)) {
					// if active
					filterObj.el.classList.add('is-active')
				} else {
					// if not active
					filterObj.el.classList.remove('is-active')
				}
			})
		})
	}
	destroy() {
		if (this.filterLogic) {
			this.filterLogic.destroy()
		}
		if (this.elClearBtn) {
			this.elClearBtn.removeEventListener('click', this.bndOnClickClear)
		}
	}
}

export default FilterInterface
